import Axios from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  fetchRoadSpecialEventAudioFailure,fetchRoadSpecialEventAudioSuccess
} from "../actions/audioPreview.action";
import * as selectors from './selector';

 
//worker functions
function* workerFetchRoadSpecialEventAudio(action) {
  try {
    const moment = require('moment');
    const access_token = yield select(selectors.access_token);

    const resp = yield call(
      Axios.post, `${process.env.REACT_APP_BASE_URL}/ivrapi` + `${process.env.REACT_APP_ROADS_EVENTS_AUDIO_URL_PATH}`,
      { textToConvert: action.payload,
        audioEncodingScheme:"WAV" }, {
      headers: {
        Authorization: 'Bearer '+access_token,
        transactionId: 'CCCRC.' + moment().unix(),
        requestTimeStamp: moment.utc().toJSON(),
      }
    });
    yield put(fetchRoadSpecialEventAudioSuccess("data:audio/wav;base64," + resp.data.data));
  } catch (e) {
    yield put(fetchRoadSpecialEventAudioFailure(e.message));
  }
}

export function* watchFetchRoadSpecialEventAudio() {
  yield takeLatest("FETCH_ROAD_SPECIAL_EVENT_AUDIO_START", workerFetchRoadSpecialEventAudio);
}

